import { businessKey } from 'queryKeys';

const FINANCIAL_RESULT = 'financialResult';

const MUTATION__SEND_APPROVE = 'sendApprove';
const MUTATION_MORE_INFO = 'moreInfo';
const MUTATION_COMMENT_INVOICE = 'commentInvoice';
const MUTATION_UNDO_INVOICE = 'undoInvoice';
const MUTATION_MARK_INVOICE = 'markAsPaidInvoice';
const MUTATION_EXPORT_FR = 'exportFR';
const MUTATION_EXPORT_INVOICES = 'exportInvoices';
const MUTATION_REPLACE_INVOICE_ATTACHMENT = 'replaceInvoiceAttachment';

const frQuery = businessKey.query(FINANCIAL_RESULT);

export const grid = frQuery.grid();
export const chart = frQuery.chart();
export const mutations = frQuery.mutations();
export const details = frQuery.details();
export const model = frQuery.exact();

export const create = mutations.create();
export const update = mutations.update();

export const addComment = mutations.addComment();
export const remove = mutations.delete();
export const approve = mutations.approve();
export const reject = mutations.reject();
export const undo = mutations.undo();

export const moreInfo = mutations.mutate(MUTATION_MORE_INFO);
export const commentInvoice = mutations.mutate(MUTATION_COMMENT_INVOICE);
export const undoInvoice = mutations.mutate(MUTATION_UNDO_INVOICE);
export const replaceInvoiceAttachment = mutations.mutate(
  MUTATION_REPLACE_INVOICE_ATTACHMENT
);

export const markAsPaid = mutations.mutate(MUTATION_MARK_INVOICE);
export const exportFR = mutations.mutate(MUTATION_EXPORT_FR);

export const exportInvoices = mutations.mutate(MUTATION_EXPORT_INVOICES);
export const sendForApproval = mutations.mutate(MUTATION__SEND_APPROVE);
